"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentTitle = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const common_1 = require("../../../../../common");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const AssignmentStateDropdown_1 = require("./AssignmentStateDropdown");
const AssignmentSubmittedDropdown_1 = require("./AssignmentSubmittedDropdown");
const AssignmentTypeDropdown_1 = require("./AssignmentTypeDropdown");
const DeleteListBtn_1 = require("./DeleteListBtn");
const Container001Styled = styled_components_1.default.div `
	${props => (props.$isDesktop ? desktopStyles : props.$isTablet ? tabletStyles : mobileStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	&.header {
		display: flex;
		flex-direction: row;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-end;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		.active-bar {
			display: flex;
			flex-direction: column;
			gap: 8px;
			align-items: flex-start;
			justify-content: center;
			flex: 1;
			position: relative;
			padding: 20px;
			background: var(--color-silver, #f3f4f8);
		}

		.drop-wrap {
			display: flex;
			flex-direction: row;
			gap: 8px;
			align-items: center;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;
			width: 100%;

			/* 가장 작은 모바일 폭에서도 드롭다운 3개(응시여부/진행상태/출제유형)가 잘리지 않도록
			   행 너비를 균등 분배하고 min-width:0 으로 콘텐츠보다 더 줄어들 수 있게 한다. */
			> .dropdown {
				flex: 1 1 0;
				min-width: 0;

				/* 폭이 더 줄어들면 라벨이 넘치지 않고 ... 로 말줄임되도록:
				   필드를 flex 행으로, 라벨(placeholder)은 남는 폭 차지+축소 허용, 화살표는 고정. */
				.dropdown-field {
					display: flex;
					align-items: center;
					justify-content: space-between;
					gap: 4px;
					min-width: 0;
					overflow: hidden;
				}

				.dropdown-field .placeholder,
				.dropdown-field .placeholder2 {
					flex: 1;
					min-width: 0;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.dropdown-field .arrow-down,
				.dropdown-field .arrow-up,
				.dropdown-field svg {
					flex-shrink: 0;
				}
			}
		}
	}
`;
const tabletStyles = (0, styled_components_1.css) `
	&.header {
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		flex-wrap: wrap;

		.active-bar {
			display: flex;
			flex-direction: row;
			gap: 12px;
			align-items: center;
			justify-content: flex-end;
			flex: 1;
			flex-wrap: wrap;
			position: relative;
		}
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	&.header {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		flex-wrap: wrap;

		.active-bar {
			display: flex;
			flex-direction: row;
			gap: 14px;
			align-items: center;
			justify-content: flex-end;
			flex-shrink: 0;
			position: relative;
			flex-wrap: wrap;
			flex: 1;
		}
	}

	${props => props.$isBackOffice &&
    (0, styled_components_1.css) `
			flex: 1;
		`}
`;
exports.AssignmentTitle = react_1.default.memo(({ isHideSelectDelBtn = false, isBackOffice = false, isTest = false, isSurvey = false, isTeacher = false, checkList = [], status, type, keyword, submitted = 'select', setStatus, setType, setKeyword, setSubmitted, }) => {
    const { isDesktop, isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const renderDropDown = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            setSubmitted && (react_1.default.createElement(AssignmentSubmittedDropdown_1.AssignmentSubmittedDropdown, { submitted: submitted, setSubmitted: setSubmitted })),
            react_1.default.createElement(AssignmentStateDropdown_1.AssignmentStateDropdown, { status: status, setStatus: setStatus, isBackOffice: isBackOffice }),
            !isSurvey && react_1.default.createElement(AssignmentTypeDropdown_1.AssignmentTypeDropdown, { type: type, setType: setType })));
    }, [type, status, submitted, isBackOffice, isTest, isSurvey, setSubmitted]);
    const handlerUpdateSearch = (value) => {
        // @ts-ignore
        setKeyword(value?.keyword);
    };
    return (react_1.default.createElement(Container001Styled, { className: "header", "$isDesktop": isDesktop, "$isTablet": isTablet, "$isMobile": isMobile, "$isBackOffice": isBackOffice },
        !isHideSelectDelBtn && isTeacher && !isMobile ? (react_1.default.createElement(DeleteListBtn_1.DeleteListBtn, { isTest: isTest, isOneDel: false, deleteList: checkList })) : (react_1.default.createElement("div", null)),
        react_1.default.createElement("div", { className: "active-bar", style: { gap: !isMobile && 14 } },
            isMobile ? (react_1.default.createElement("div", { className: "drop-wrap" }, renderDropDown)) : (renderDropDown),
            react_1.default.createElement(common_1.SearchBar, { className: `${!isMobile ? 'search-bar-qna' : 'search-bar-mobile'}`, filterData: "keyword", defaultSearchContent: keyword, handlerFilterList: handlerUpdateSearch, isTest: isTest }))));
});
